var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.is_admin)?_c('div',[_c('div',{staticClass:"has-text-warning"},[_vm._v("["+_vm._s(_vm.trkey)+"] "),_vm._t("default")],2)]):_vm._e(),_vm._v(" "),(_vm.translated)?_c('div',{domProps:{"innerHTML":_vm._s(_vm.translated)}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }